import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toastErrorr, toastSuccesss } from "../../../../Helper/ToastMessage";
import { BaseUrl } from "../../../../Helper/BaseUrl";

// Get Table Data
export const BackWashingTableDataAPI = createAsyncThunk("BackWashingTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WTP_FilterBatteryNoID,
        M_UserID,
        token,
        From,
        To,
        Flag,

    } = data

    console.log("Flag",Flag)
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
 
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_BackWashingFilter_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_FilterBatteryNoID=${M_WTP_FilterBatteryNoID ? M_WTP_FilterBatteryNoID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const  BackWashingTableDataSlice = createSlice({
    name: " BackWashingTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase( BackWashingTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase( BackWashingTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase( BackWashingTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const  BackWashingTableDataReducer =  BackWashingTableDataSlice.reducer

export const BackWashingTableExportDataAPI = createAsyncThunk("BackWashingTableExportData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WTP_FilterBatteryNoID,
        M_UserID,
        token,
        From,
        To,
        Flag,

    } = data

    console.log("Flag",Flag)
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
 
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_BackWashingFilter_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_FilterBatteryNoID=${M_WTP_FilterBatteryNoID ? M_WTP_FilterBatteryNoID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const  BackWashingTableExportDataSlice = createSlice({
    name: " BackWashingTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase( BackWashingTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase( BackWashingTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase( BackWashingTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const  BackWashingTableExportDataReducer =  BackWashingTableExportDataSlice.reducer


// Get Table Data
export const  BackWashingExportTableDataAPI = createAsyncThunk(" BackWashingExportTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WTP_PumpingStationID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WTP_T_WTP_Security_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_PumpingStationID=${M_WTP_PumpingStationID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const  BackWashingExportTableDataSlice = createSlice({
    name: " BackWashingExportTableData",
    initialState: {
        isExportLoading: false,
        GardenExporttableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase( BackWashingExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase( BackWashingExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.GardenExporttableData = action.payload;
        });
        builder.addCase( BackWashingExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.GardenExporttableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const  BackWashingExportTableDataReducer =  BackWashingExportTableDataSlice.reducer

// Delete Table Data

export const  BackWashingDeleteAPI = createAsyncThunk(" BackWashingDelete", async ({ data }) => {

    const {
        T_WTP_BackWashingFilterID,  
        M_UserID,
        handleIsPost,
        token,
        Flag
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_WTP_BackWashingFilterID", T_WTP_BackWashingFilterID);
    formdata.append("M_UserID", M_UserID);
    
    var requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    
    fetch(`${BaseUrl}/APKDashboard/WEB_WTP_T_WTP_BackWashingFilter_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                // handleDeleteCloseClick()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)
                // handleDeleteCloseClick()
            }
            return result

        })
})

const  BackWashingDeleteSlice = createSlice({
    name: " BackWashingDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase( BackWashingDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase( BackWashingDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;
            // toastSuccesss(action.payload.message)
        });
        builder.addCase( BackWashingDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const  BackWashingDeleteReducer =  BackWashingDeleteSlice.reducer